/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class NewsService extends __BaseService {
  static readonly getNewsListPath = '/news';
  static readonly getSingleNewsPath = '/news/{slug}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get List of space news.
   * @param params The `NewsService.GetNewsListParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Limit value for news list.
   *
   * - `lang`: Language short code.
   */
  getNewsListResponse(params: NewsService.GetNewsListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.paginate != null) __params = __params.set('paginate', params.paginate.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/news`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get List of space news.
   * @param params The `NewsService.GetNewsListParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Limit value for news list.
   *
   * - `lang`: Language short code.
   */
  getNewsList(params: NewsService.GetNewsListParams): __Observable<null> {
    return this.getNewsListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get single news details
   * @param params The `NewsService.GetSingleNewsParams` containing the following parameters:
   *
   * - `slug`: slug of news.
   *
   * - `lang`: Language short code.
   */
  getSingleNewsResponse(params: NewsService.GetSingleNewsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/news/${encodeURIComponent(String(params.slug))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get single news details
   * @param params The `NewsService.GetSingleNewsParams` containing the following parameters:
   *
   * - `slug`: slug of news.
   *
   * - `lang`: Language short code.
   */
  getSingleNews(params: NewsService.GetSingleNewsParams): __Observable<null> {
    return this.getSingleNewsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module NewsService {

  /**
   * Parameters for getNewsList
   */
  export interface GetNewsListParams {

    /**
     * Limit value for pagination.
     */
    paginate: number;

    /**
     * Limit value for news list.
     */
    page: number;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for getSingleNews
   */
  export interface GetSingleNewsParams {

    /**
     * slug of news.
     */
    slug: string;

    /**
     * Language short code.
     */
    lang?: string;
  }
}

export { NewsService }
